import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Header() {
  const { t, i18n } = useTranslation('common');
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path: string) => location.pathname === path;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-sm' : 'bg-white/95 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-[1440px] mx-auto px-10 py-6 flex items-center justify-between">
        <Link to="/" className="flex items-center cursor-pointer">
          <img
            src="https://static.readdy.ai/image/10b7ac0fbf41ce1a59b0bea485f34628/e1b684b4d12b3afad37e95ffa0daaac0.png"
            alt="DR Group"
            className="h-10 w-auto object-contain object-left"
          />
        </Link>

        <nav className="flex items-center gap-8">
          <Link
            to="/"
            className={`text-sm font-medium transition-colors duration-200 cursor-pointer ${
              isActive('/')
                ? 'text-[#0A2D50]'
                : 'text-gray-600 hover:text-[#1BCDFF]'
            }`}
          >
            {t('nav.home')}
          </Link>
          <Link
            to="/about"
            className={`text-sm font-medium transition-colors duration-200 cursor-pointer ${
              isActive('/about')
                ? 'text-[#0A2D50]'
                : 'text-gray-600 hover:text-[#1BCDFF]'
            }`}
          >
            {t('nav.about')}
          </Link>
          <Link
            to="/structure"
            className={`text-sm font-medium transition-colors duration-200 cursor-pointer ${
              isActive('/structure')
                ? 'text-[#0A2D50]'
                : 'text-gray-600 hover:text-[#1BCDFF]'
            }`}
          >
            {t('nav.structure')}
          </Link>
          <Link
            to="/contact"
            className={`text-sm font-medium transition-colors duration-200 cursor-pointer ${
              isActive('/contact')
                ? 'text-[#0A2D50]'
                : 'text-gray-600 hover:text-[#1BCDFF]'
            }`}
          >
            {t('nav.contact')}
          </Link>

          {/* Language Switcher */}
          <div className="flex items-center gap-2 ml-4 pl-4 border-l border-gray-300">
            <button
              onClick={() => i18n.changeLanguage('de')}
              className={`text-sm font-medium transition-colors duration-200 cursor-pointer ${
                i18n.language === 'de' ? 'text-[#0A2D50]' : 'text-gray-400 hover:text-[#0A2D50]'
              }`}
            >
              DE
            </button>
            <span className="text-gray-300">|</span>
            <button
              onClick={() => i18n.changeLanguage('en')}
              className={`text-sm font-medium transition-colors duration-200 cursor-pointer ${
                i18n.language === 'en' ? 'text-[#0A2D50]' : 'text-gray-400 hover:text-[#0A2D50]'
              }`}
            >
              EN
            </button>
            <span className="text-gray-300">|</span>
            <button
              onClick={() => i18n.changeLanguage('es')}
              className={`text-sm font-medium transition-colors duration-200 cursor-pointer ${
                i18n.language === 'es' ? 'text-[#0A2D50]' : 'text-gray-400 hover:text-[#0A2D50]'
              }`}
            >
              ES
            </button>
          </div>
        </nav>
      </div>
    </header>
  );
}